import React from 'react';
import './About.css';

const About = () => {
  const teamMembers = [
    {
      name: 'Mangesh Mahajan',
      badge: 'Our CEO',
      image: 'https://preciseca.com/wp-content/uploads/2025/12/2-4.png',
      title: 'Mangesh Mahajan',
      lines: ['Founder CEO @Precise Integrations', 'LLP|CTO @ TallyConnects Software'],
    },
    {
      name: 'Salman Sayyed',
      badge: 'Our CTO',
      image: 'https://preciseca.com/wp-content/uploads/2025/12/Untitled-design-40.png',
      title: 'Salman Sayyed',
      lines: ['Founder CTO @Precise Integrations', 'LLP|TechLead @TallyConnects'],
    },
    {
      name: 'Praveen Sharma',
      badge: 'AVP- Channel Sales',
      image: 'https://preciseca.com/wp-content/uploads/2025/12/Untitled-design-44-e1766061697873.png',
      title: 'Praveen Sharma',
      lines: ['AVP @Precise Integrations LLP'],
      contact: '+91 9870192353 | +91-124-479488',
    },
  ];

  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="section-title">About Us</h2>

        {/* Mentor Section */}
        <div className="mentor-card">
          <div className="mentor-content">
            <span className="mentor-badge">Our Mentor</span>
            <h3 className="mentor-name">Kunal Singhal</h3>
            <p className="mentor-roles">
              Founder & Managing Director | Technopreneur | Chartered Accountant | BW 40 under 40 2022 Eazy ERP | Recibo | Cyboard School | FirstCut | S Singhal & Co | Krish Group
            </p>
            <p className="mentor-bio">
              Mr. Kunal Singhal is the mentor behind PreciseCA, providing strategic direction and deep industry guidance in building a scalable, reliable analytics platform for Tally users. With extensive experience across multiple successful ventures, he brings strong domain expertise in finance, compliance, and technology-driven business solutions.
            </p>
          </div>
          <div className="mentor-image">
            <img src="https://preciseca.com/wp-content/uploads/2025/12/kunal-sir.png" alt="Kunal Singhal" />
          </div>
        </div>

        {/* Team Grid */}
        <div className="team-grid">
          {teamMembers.map((member, i) => (
            <div key={i} className="team-card">
              <div className="team-card-image">
                <img src={member.image} alt={member.name} />
              </div>
              <span className="team-badge">{member.badge}</span>
              <h4 className="team-name">{member.title}</h4>
              {member.lines.map((line, j) => (
                <p key={j} className="team-line">{line}</p>
              ))}
              {member.contact && (
                <p className="team-contact">{member.contact}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
